import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../store/rootReducer';
import { BaseAnalyticsFrameRequest } from '../types/api.v2.types';

let aiImageAnalyticsData: BaseAnalyticsFrameRequest & {
  enterTime: string;
  exitTime: string;
  enterAiImageCount: number;
  exitAiImageCount: number;
} = {
  blockId: 0,
  frameId: 0,
  selectedPhotos: [],
  enterTime: '',
  exitTime: '',
  enterAiImageCount: 0,
  exitAiImageCount: 0,
};

// YYYY-MM-DD HH:MM:SS (KST)
const formatDate = () => {
  const now = new Date();
  const koreanTime = new Date(now.getTime() + 9 * 60 * 60 * 1000);
  return koreanTime.toISOString().slice(0, 19).replace('T', ' ');
};

export const useAiImageAnalytics = () => {
  const { block } = useSelector((state: RootState) => state.block);
  const selectedThemeId = useSelector((state: RootState) => state.theme.selectedThemeId);
  const { aiProcessedPhotos, selectedPhotos, selectedFrameIndex } = useSelector(
    (state: RootState) => state.photo
  );

  const theme = block.themes.find((t) => t.id === selectedThemeId) || block.themes[0];

  const countCompletedAiImages = useCallback(() => {
    return aiProcessedPhotos.filter((photo) => photo.characterize !== '').length;
  }, [aiProcessedPhotos]);

  // [진입 시점] ChoosePhotoPage 진입 시간 측정 (ChooseFramePage -> ChoosePhotoPage)
  const recordEntryData = useCallback(() => {
    if (!block) return;

    const frameId = theme.frames[selectedFrameIndex].frameId;

    aiImageAnalyticsData = {
      ...aiImageAnalyticsData,
      blockId: block.id,
      frameId: frameId,
      selectedPhotos: [],
      enterTime: formatDate(),
      enterAiImageCount: countCompletedAiImages(),
    };
  }, [block, theme, selectedFrameIndex, countCompletedAiImages]);

  // [진출 시점] ChoosePhotoPage 진출 시간 측정 (ChoosePhotoPage -> PrintPage)
  const recordExitData = useCallback(async () => {
    if (!block) return;

    const analyticsData = {
      ...aiImageAnalyticsData,
      selectedPhotos: selectedPhotos.filter((photo) => photo !== null),
      exitTime: formatDate(),
      exitAiImageCount: countCompletedAiImages(),
    };

    aiImageAnalyticsData = analyticsData;
    return;
  }, [block, selectedPhotos, countCompletedAiImages]);

  return {
    recordEntryData,
    recordExitData,
    getCurrentAiImageCount: countCompletedAiImages,
  };
};
